


















































































import Component from 'vue-class-component'
import { Prop, Mixins } from 'vue-property-decorator'
import DiameterTable from '@/components/dackpartner/DiameterTable.vue'
import Configuration from '@/models/dackpartner/Configuration'
import DackpartnerSupplierMixin from '@/mixins/DackpartnerSupplierMixin'
import Diameter from '@/models/dackpartner/Diameter'
import DiameterConfig from '@/models/dackpartner/DiameterConfig'

@Component({
  components: {
    DiameterTable,
  },
})
export default class AmountConfiguration extends Mixins(DackpartnerSupplierMixin) {
  @Prop({ required: true }) configuration!: Configuration
  @Prop({ required: true }) availableSuppliers!: any[]
  @Prop({ required: true }) supplierGuiData!: any[]
  @Prop({ default: false }) readonly!: boolean

  private getDiameterValue(vehicleType: string, diameter: number): number {
    const diameterConfig = (this.configuration.diameterConfig as DiameterConfig)[vehicleType]
    if (!diameterConfig) return 0
    const item = diameterConfig.find((item: Diameter) => item.inch === diameter)
    return item ? item.amount : 0
  }

  private updateDiameterValue(vehicleType: string, diameter: number, value: number): void {
    const diameterConfig = (this.configuration.diameterConfig as DiameterConfig)[vehicleType]
    if (!diameterConfig) return
    const item = diameterConfig.find((item: Diameter) => item.inch === diameter)
    console.log(item)
    if (item) {
      item.amount = typeof value === 'string' ? parseFloat(value) || 0 : value
    }
  }

  private get profitPercentRules(): Array<(v: any) => boolean | string> {
    return [
      (v: any) =>
        (v !== null && v !== undefined && v !== '' && v >= 0) || this.$t('Must be greater than or equal to 0'),
    ]
  }

  private get profitAmountRules(): Array<(v: any) => boolean | string> {
    return [
      (v: any) =>
        (v !== null && v !== undefined && v !== '' && v >= 0) || this.$t('Must be greater than or equal to 0'),
    ]
  }

  private get diameterAmountRules(): Array<(v: any) => boolean | string> {
    return [
      (v: any) =>
        (v !== null && v !== undefined && v !== '' && v >= 0) || this.$t('Must be greater than or equal to 0'),
    ]
  }

  public validateForms(): boolean {
    let isValid = true

    // Validate amount form
    if (this.$refs.amountForm) {
      const amountFormValid = (this.$refs.amountForm as any).validate()
      isValid = isValid && amountFormValid
    }

    // Validate diameter form
    if (this.$refs.diameterForm) {
      const diameterFormValid = (this.$refs.diameterForm as any).validate()
      isValid = isValid && diameterFormValid
    }

    return isValid
  }
}
